import Modal from "../../../components/atoms/Modal";
import Icon from "../../../components/atoms/Icon";
import BtnModal from "../../../components/atoms/BtnModal";
import React, {useEffect, useState} from "react";
import {useStorehouseContext} from "../StorehouseContext";

const ChangeDevicePasswordModal = () => {
    const {
        modalState,
        closeModal,
        generateBrokerPassword,
        editDevice
    } = useStorehouseContext();

    const [password, setPassword] = useState()

    useEffect(() => {
        console.log(modalState.selectedItem)
        if (modalState.selectedItem && modalState.mode === "edit") {
            setPassword(modalState.selectedItem.password)
        }
    }, [modalState]);


    const onCreatePasswordClick = () => {
        setPassword(generateBrokerPassword())
    }
    const onBtnClick = async () => {
        await editDevice(modalState.selectedItem.id, password)
    }

    const isOpen = modalState.mode === "edit" && modalState.isOpen;
    if (!isOpen) {
        return null;
    }
    return (
        <>
            <Modal
                title={`تغییر کلمه عبور ${modalState.selectedItem.serialNumber}`}
                closeModal={closeModal}>
                {/*body*/}

                <div className="flex flex-col w-full">
                    <label
                        htmlFor="name"
                        className="text-dark-blue-200 text-12 font-normal leading-5 mb-2.5">
                        کلمه عبور
                    </label>
                    <div
                        className="flex flex-row justify-between  bg-gray-chart-200 w-full px-3.5 gap-2.5 items-center rounded-sm  h-12.6">
                        <div className="flex flex-row items-center gap-2.5">
                            <Icon iconName="password-check"/>
                            <input
                                value={password}
                                id="password"
                                type="text"
                                placeholder={" 954tM95nKJE# "}
                                className="bg-gray-chart-200 outline-none text-dark-blue-200 text-14 py-3.5"

                                onChange={(event) => {
                                    setPassword(event.target.value)

                                }}
                            />
                        </div>
                        <button
                            // id={id.id}
                            onClick={onCreatePasswordClick}
                            className="flex flex-row justify-center items-center w-36 font-normal text-12  text-dark-blue-200 leading-5 border-r-1 border-gray3 pr-2.5">
                            ساخت کلمه عبور اتفاقی
                        </button>
                    </div>
                </div>
                {/*footer*/}
                <div className="flex items-center justify-end pt-5.5">
                    <BtnModal text={"تایید اطلاعات و ویرایش"} accept={onBtnClick}/>
                </div>
            </Modal>
            <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
        </>
    );
}
export default ChangeDevicePasswordModal